/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ProfessionalComplianceInfoResponse = {
  type: 'all-of',
  contains: [{
    type: 'Response',
  }, {
    properties: {
      data: {
        type: 'all-of',
        contains: [{
          type: 'ProfessionalComplianceInfoResponseData',
        }],
        isRequired: true,
      },
    },
  }],
} as const;
